import { routes as allPatientReportsRoutes } from "./all/routes";
import { routes as registrationRoutes } from "./registration/routes";
import { routes as visitReportRoutes } from "./visits/routes";
import { routes as admissionRoutes } from "./admission/routes";
import { routes as currentInpatientRoutes } from "./current-inpatients/routes";
import { routes as gatePassRoutes } from "./gate-pass/routes";
import { routes as dischargeRoutes } from "./discharge/routes";
import { routes as opDiagnosisReport } from "./op-diagnosis-report/routes";
import { routes as ipDiagnosisReport } from "./ip-diagnosis-report/routes";

import { routes as progressnotesRoutes } from "./progress-notes/routes";
import { routes as tbscreeningReport } from "./TBScreening/routes";
export const routes = (prefix=`reports`, pre=`patients`) => [
    ...allPatientReportsRoutes(prefix,pre),
    ...registrationRoutes(prefix, pre),
    ...visitReportRoutes(prefix, pre),
    ...admissionRoutes(prefix, pre),
    ...currentInpatientRoutes(prefix, pre),
    ...gatePassRoutes(prefix, pre),
    ...dischargeRoutes(prefix, pre),
    ...opDiagnosisReport(prefix, pre),
    ...tbscreeningReport(prefix, pre),
    ...ipDiagnosisReport(prefix, pre),
    
    ...progressnotesRoutes(),
    {
        name: `${prefix}.${pre}`,
        path: `/${prefix}/${pre}`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}`,
                PageDescription: `Patient reports`
            },
        },
    },
    {
        name: `${prefix}.${pre}.nhif-visits-report.index`,
        path: `/${prefix}/${pre}/nhif-visits-report`,
        component: () => import('./nhif/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.nhif-visits-report.index`,
                PageDescription: "Patient Reports: NHIF Visits report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.documents-report.index`,
        path: `/${prefix}/${pre}/documents-report`,
        component: () => import('./documents/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.documents-report.index`,
                PageDescription: "Patient Reports: Documents report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.mini-discharge-report.index`,
        path: `/${prefix}/${pre}/mini-discharge-report`,
        component: () => import('./mini-discharge/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.mini-discharge-report.index`,
                PageDescription: "Patient Reports: Mini-Discharge report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.admission-history.index`,
        path: `/${prefix}/${pre}/admission-history-report`,
        component: () => import('./admission-history/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.admission-history.index`,
                PageDescription: "Patient Reports: Admission History report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.daily-report.index`,
        path: `/${prefix}/${pre}/daily-report-report`,
        component: () => import('./daily-report/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.daily-report.index`,
                PageDescription: "Patient Reports: Daily Report",
            },
        },
    },
];